module.exports = __webpack_public_path__ + "static/media/bushu-10.aad2021f.png";